import { useEffect, useState } from "react";
import { useAuth } from "../auth/useAuth";
import { User } from "../models/authentication/user";

type UserInformation = {
  logoLink: string;
  getDefaultLink: (user?: User) => string;
};

export function getDefaultLink(user?: User): string {
  if (!user) {
    return "/";
  }
  if (user.roles.includes("ADMIN") || user.roles.includes("SECRETARY")) {
    return "/school";
  } else if (user.roles.includes("TEACHER")) {
    return "/absences";
  } else {
    return "/";
  }
}

function useUserInformation(): UserInformation {
  const [logoLink, setLogoLink] = useState<string>("/");
  const { user } = useAuth();

  useEffect(() => {
    setLogoLink(getDefaultLink(user));
  }, [user]);

  return {
    logoLink,
    getDefaultLink,
  };
}

export default useUserInformation;
